import * as React from 'react';

import DeliverableSubHeader from '../../deliverable-sub-header/DeliverableSubHeader';
import DeliverableMediaAttachmentsForDeliverable from '../../../media/parts/DeliverableMediaAttachmentsForDeliverable';
import DeliverableAttachmentUploader from '../../deliverable-attachment-uploader/DeliverableAttachmentUploader';

import { __t, applyTranslations } from 'utils/language';

import type { Deliverable, DeliverableAttachment, DeliverableAttachmentType } from 'types';
import type { ReplacementUploaderProps }
  from 'modules/deliverables/components/media/parts/media-for-insights/RenderReplacementUploader.type';

applyTranslations(require('./deliverable-insights.i18n.json'));

type Props = {
  isEditMode: boolean,
  isForBrand?: boolean,
  deliverable: Deliverable,
  attachments: Array<DeliverableAttachment>,
  mode: DeliverableAttachmentType,
  onEditMode: (isEditMode: boolean) => void,
  onUpdate: (tempAttachments: Array<DeliverableAttachment>) => void,
  onDeleteAttachments?: (deliverableAttachment: Array<DeliverableAttachment>) => void,
  onReplaceAttachment?: (replacement: DeliverableAttachment, current: DeliverableAttachment) => void
}

const msgKey = 'deliverable_insights';

const DeliverableInsights = ({
  isEditMode,
  isForBrand,
  attachments = [],
  deliverable,
  mode,
  onDeleteAttachments,
  onReplaceAttachment,
  onEditMode,
  onUpdate
}: Props) => {
  const { deliverableType } = deliverable;
  const isNonEditableEmptyMode = !(isEditMode || attachments.length || !isForBrand);

  return (
    <React.Fragment>
      <DeliverableSubHeader
        title={__t(`${msgKey}.labels.${deliverableType}.${mode}`)}
        instruction={isNonEditableEmptyMode ? ''
          : __t(`${msgKey}.labels.${deliverableType}.instruction.${isForBrand ? 'brand' : 'influencer'}.${mode}`)}
        directon={isNonEditableEmptyMode ? 'row' : 'column'}
        emptyNote={isNonEditableEmptyMode ? __t(`${msgKey}.${mode}_empty_note`) : ''}
      />
      {
      !isNonEditableEmptyMode && (
        <DeliverableMediaAttachmentsForDeliverable
          isNewDeliverable
          canUpload={isEditMode}
          deliverable={deliverable}
          attachments={attachments}
          onEditMode={() => onEditMode(!isEditMode)}
          onDeleteAttachments={onDeleteAttachments}
          onReplaceAttachment={onReplaceAttachment}
          mode={mode}
          placeholderForUpload={(
            <DeliverableAttachmentUploader
              size="custom"
              deliverable={deliverable}
              attachmentType={mode}
              onUpdate={onUpdate}
            />
          )}
          renderReplacementUploader={(props: ReplacementUploaderProps, forwardedRef: React.ForwardedRef<HTMLInputElement>) => (
            <DeliverableAttachmentUploader
              size="custom"
              deliverable={deliverable}
              attachmentType={mode}
              onUpdate={props.onUpdate}
              forwardedRef={forwardedRef}
              isReplacement
            />
          )}
        />
      )
    }
    </React.Fragment>
  );
};

export default DeliverableInsights;
